import {Component, OnInit, signal, WritableSignal, ChangeDetectionStrategy} from '@angular/core';
import {TitleComponent} from '@/app/shared/components/title/title.component';
import {MatchService} from '@services/match.service';
import {ArticleService} from '@services/article.service';
import {NewsCardComponent} from '@components/news-card/news-card.component';
import {Title} from '@angular/platform-browser';
import {UpcomingMatchsComponent} from '@components/upcoming-matchs/upcoming-matchs.component';
import {SliderService} from '@services/slider.service';
import {Slider} from '@/app/core/models/slider';
import {TranslatePipe} from '@ngx-translate/core';
import {LastVideosComponent} from '@components/last-videos/last-videos.component';
import {ActivatedRoute, Router} from '@angular/router';
import {ToastService} from '@services/toast.service';
import {FullscreenSliderComponent} from '@components/fullscreen-slider/fullscreen-slider.component';
import {ArticleTiny} from '@/app/core/models/article';
import {CalendarGroupByDate} from '@/app/core/models/calendar/calendarGroupByDate';
import {ButtonComponent, MaxButtonComponent} from '@/app/shared';
import {EventFilterComponent} from '@/app/shared/components/event-filter/event-filter.component';
import {TicketingWidgetComponent} from '@components/ticketing-widget/ticketing-widget.component';
import {EventType, EventTypeList} from '@/app/core/models/calendar/eventCalendar';

@Component({
  selector: 'app-home',
	imports: [
		MaxButtonComponent,
		TitleComponent,
		ButtonComponent,
		NewsCardComponent,
		UpcomingMatchsComponent,
		TranslatePipe,
		LastVideosComponent,
		FullscreenSliderComponent,
		EventFilterComponent,
		TicketingWidgetComponent,
	],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './home.component.html',
})
export class HomeComponent implements OnInit {

	constructor(
		private readonly matchService: MatchService,
		private readonly sliderService: SliderService,
		private readonly articleService: ArticleService,
		private readonly titleService: Title,
		private readonly activeRoute: ActivatedRoute,
		private readonly toastService: ToastService,
		private router: Router,
	) {}

	eventCalendarUpcoming: CalendarGroupByDate[] = [];
	filteredMatches: CalendarGroupByDate[] = [];

	articles: ArticleTiny[] = [];
	sliders: Slider[] = [];

	selectedEvents: WritableSignal<EventType[]> = signal(EventTypeList);

	ngOnInit(): void {
		this.activeRoute.queryParams.subscribe((params) => {
			if (params['error'] === 'login_cancelled') {
				this.toastService.show('Erreur lors de la connexion !', 'error', 5000);
				this.router.navigate([], {
					relativeTo: this.activeRoute,
					queryParams: { error: null },
					queryParamsHandling: 'merge',
					replaceUrl: true
				});
			}
		});

		this.loadSliders();
		this.loadCalendar();
		this.loadRecentArticles();
    }

	private loadCalendar(): void {
		this.matchService.get5UpcomingMatches().subscribe((data: CalendarGroupByDate[]) => {
			this.eventCalendarUpcoming = data;
			this.updateFilteredMatches();
		});
	}

	private loadRecentArticles() {
		this.articleService.getThreeRecentArticles().subscribe((data: ArticleTiny[]) => {
			this.articles = data;
		})
	}

	private loadSliders() {
		this.sliderService.getAllActiveSlider().subscribe((data: Slider[]) => {
			this.sliders = data;
		})
	}

	updateFilteredMatches(): void {
		this.filteredMatches = this.eventCalendarUpcoming
			.map(group => {
				const filtered = group.eventsCalendar.filter(eventCalendar =>
					this.selectedEvents().includes(eventCalendar.eventType!)
				);
				return {
					date: group.date,
					eventsCalendar: filtered
				};
			})
			.filter(group => group.eventsCalendar.length > 0);
	}

	toggleEventType(eventType: EventType): void {
		this.selectedEvents.update(list =>
			list.includes(eventType) ? list.filter(r => r !== eventType) : [...list, eventType]
		);
		this.updateFilteredMatches();
	}
}
